import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { keyUri, config } from "../key";
import { toast } from "react-toastify";

const initialState = {
  currentPricing: null,
  loading: false,
  hasError: false,
};

export const pricingSlice = createSlice({
  name: "pricing",
  initialState,
  reducers: {
    getPricingRequest: (state) => {
      state.loading = true;
      state.hasError = false;
    },
    getPricingFailure: (state) => {
      state.loading = false;
      state.hasError = true;
    },
    getCurrentPricingSuccess: (state, { payload }) => {
      state.loading = false;
      state.currentPricing = payload;
    },
  },
});

export const {
  getPricingRequest,
  getPricingFailure,
  getCurrentPricingSuccess,
} = pricingSlice.actions;

export const pricingSelector = (state) => state.pricing;

// Create a new pricing model
export const createPricing = (pricingData) => async (dispatch) => {
  try {
    const response = await axios.post(keyUri.BACKEND_URI + "/createPrice", {
      ...pricingData,
      adminId: pricingData.adminId,
    });

    dispatch({ type: "CREATE_PRICING_SUCCESS", payload: response.data });
    console.log(response)
    toast.success(response.data.message, { position: "top-center", autoClose: 2500 });
    dispatch(fetchPricing(response.data.data.adminId))

  } catch (error) {
    console.error("Error saving pricing:", error);
    dispatch({ type: "CREATE_PRICING_ERROR", payload: error.response?.data || error.message });
  }
};

// Fetch a single pricing model by ID
export const fetchPricing = () => async (dispatch) => {
  dispatch(getPricingRequest());
  try {
    const { data } = await axios.get(keyUri.BACKEND_URI + `/api/get-all-pricemodals`, config);
    dispatch(getCurrentPricingSuccess(data));
  } catch (error) {
    dispatch(getPricingFailure());
  }
};



// Update an existing pricing model
export const updatePricing = (values) => async (dispatch) => {
  dispatch(getPricingRequest());
  try {
    const { data } = await axios.put(
      `${keyUri.BACKEND_URI}/updatePricemodal/${values.adminId}`,
      values,
      config
    );

    toast.success(data.message, { position: "top-center", autoClose: 2500 });

    // Fetch updated pricing using adminId
    dispatch(fetchPricing(values.adminId));
  } catch (error) {
    const errorMsg = error?.response?.data?.msg || "Error updating pricing";
    toast.error(errorMsg, { position: "top-center", autoClose: 2500 });

    dispatch(getPricingFailure());
  }
};;

export default pricingSlice.reducer;
